export const apiUrls: Record<string, string> = {
  stage: "https://rest.staging.wagmi.productions",
  production: "https://rest.coincap.io",
  development: "https://rest.staging.wagmi.productions",
};

export const newApiUrls: Record<string, string> = {
  stage: "https://restapi.staging.wagmi.productions",
  production: "https://restapi.production.wagmi.productions",
  development: "https://restapi.staging.wagmi.productions",
};

export const getApiUrl = (env: string) => {
  const newBackend = process.env.NODE_ENV === 'development' && localStorage.getItem('use-new-backend') === 'true';
  if (newBackend) return newApiUrls[env]
  return apiUrls[env]
}

export const siteUrls: Record<string, string> = {
  stage: "https://staging.wagmi.productions",
  production: "https://coincap.io",
  development: "http://localhost:8000",
};

export const swagggerDocUrls: Record<string, string> = {
  stage: "https://rest.staging.wagmi.productions/api-docs.json",
  production: "https://rest.coincap.io/api-docs.json",
  development: "https://rest.staging.wagmi.productions/api-docs.json",
};

export const newSwagggerDocUrls: Record<string, string> = {
  stage: "https://restapi.staging.wagmi.productions/api-docs.json",
  production: "https://restapi.production.wagmi.productions/api-docs.json",
  development: "https://restapi.staging.wagmi.productions/api-docs.json",
};

export const getSwagggerDocUrl = (env: string) => {
  const newBackend = process.env.NODE_ENV === 'development' && localStorage.getItem('use-new-backend') === 'true';
  if (newBackend) return newSwagggerDocUrls[env]
  return swagggerDocUrls[env]
}
 
export const FIAT_ENABLED = true

// CoinCap GraphQL endpoint — public, no API key required. Used for in-modal
// price lookups (e.g. staking modal) so the SPA bundle doesn't have to call
// the /v3 REST API keyless (which is being closed off).
export const graphqlUrls: Record<string, string> = {
  stage: "https://graphql.staging.wagmi.productions",
  production: "https://graphql.coincap.io",
  development: "https://graphql.staging.wagmi.productions",
};

export const getGraphqlUrl = (env: string) => graphqlUrls[env]
